import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';
import QuestionManagerMain from './QuestionManagerMain';
import Logo from '../../assets/images/logos/logo2.png';
import Swal from 'sweetalert2';

const QuestionManagerPage = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        Swal.fire({
            title: "Are you sure?",
            text: "You will be logged out of your account.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#1e40af',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, logout'
        }).then((result) => {
            if (result.isConfirmed) {
            localStorage.removeItem('guest_user_role');
            localStorage.removeItem('guest_access_token');
            localStorage.removeItem('guest_refresh_token');
            sessionStorage.removeItem('guest_user_role');
            Swal.fire({
                title: 'Logged Out',
                text: 'You have successfully logged out.',
                icon: 'success',
                timer: 1500,
                showConfirmButton: false,
                confirmButtonColor: '#1e40af'
            }).then(() => {
                navigate('/login');
            });
            }
        });
    };

    return (
        <>
            <header className="header-area">
                <div className="menu-part" style={{ borderBottom: '1px solid #E8ECF4', background: '#fff' }}>
                    <div className="container">
                        <div style={{ padding: '14px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Link to="/dashboard/institution?role=institution" className="logo-text">
                                <img src={Logo} alt="Institution Logo" style={{ height: '55px' }} />
                            </Link>
                            <button
                                type="button"
                                onClick={handleLogout}
                                className="react-btn-primary"
                                style={{
                                    background: '#1e40af',
                                    border: '2px solid #1e3a8a',
                                    padding: '8px 20px',
                                    borderRadius: '8px',
                                    color: '#fff',
                                    fontWeight: '600',
                                    fontSize: '14px',
                                    boxShadow: '0 4px 8px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.3)',
                                    textDecoration: 'none',
                                    display: 'inline-block',
                                    textTransform: 'none',
                                    cursor: 'pointer'
                                }}
                            >
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            </header>
            <Breadcrumb pageTitle="Question Manager" />
            <QuestionManagerMain />
        </>
    );
};

export default QuestionManagerPage;
